
const getLineMovement = (i: number, length: number, thinkness: number) => {
  const offset = -((length * thinkness) / 2)
  return offset + (thinkness / 2) + (i * thinkness)
}

export default getLineMovement